import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import client from "../api/client";

function RegisterPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [agreedToPolicy, setAgreedToPolicy] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      return setError("Passwords do not match.");
    }
    
    if (password.length < 8) {
     return setError("Password must be at least 8 characters.");
    }

    if (!agreedToPolicy) {
      return setError("You must agree to the Privacy Policy to register.");
    }

    setIsSubmitting(true);

    try {
      await client.post("/register", { email, password });
      navigate("/check-email");
    } catch (err) {
      if (err.response?.status === 409) {
        setError("An account with that email already exists.");
      } else {
        setError("Registration failed. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="AuthPage">
      <h1>Create Account</h1>

      {error && <p className="error">{error}</p>}

      <form onSubmit={handleSubmit}>
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        <label>
          Confirm Password
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </label>

        <div style={{ 
         display: "flex", 
         flexDirection: "row",
         alignItems: "center", 
         gap: "8px",
         marginBottom: "16px"
       }}>
        <input
         type="checkbox"
         checked={agreedToPolicy}
         onChange={(e) => setAgreedToPolicy(e.target.checked)}
        />
         <span>I agree to the{" "}
          <Link to="/privacy-policy" target="_blank">
          Privacy Policy
         </Link>
        </span>
       </div>

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Creating Account..." : "Create Account"}
        </button>
      </form>

      <p>
        Already have an account? <Link to="/login">Log in</Link>
      </p>
    </main>
  );
}

export default RegisterPage;